<template>
    <div v-if="!profile.isAuthenticated">
        <hp5-semantic size-selection="sm">
        <p><a data-analytics="login-2" href="/public/login/?referrer=%2Ffcp%2Fcsearch">Sign in</a> to see your coverage</p></hp5-semantic>
    </div>
</template>
<script setup lang="ts">
    const { profile } = useFCPModel()
</script>